
import { ComputedValueGetter } from "../../../../utils/ComputedValueGetter.js";

const navigator = globalThis.navigator;

/**
 * Checks if a device has a touch screen, which coould be a mobile device or a touch screen monitor
 **/
export function isTouchScreenDevice ()
{
  try {
    const touchPoints = navigator?.maxTouchPoints;
    if (touchPoints != null){
      return touchPoints > 0;
    }
    if ('ontouchstart' in window){
      return true;
    }
    return null;
  }
  // eslint-disable-next-line no-empty
  catch { }
  return null;
}

export const IsTouchScreenDevice = new ComputedValueGetter({
  isLazy: true,
  computeFn: isTouchScreenDevice
});